import { en } from '@/shared/locales/en.ts'
import { fr } from '@/shared/locales/fr.ts'

export const DEFAULT_LANGUAGE = 'en'
export const LANGUAGES = [DEFAULT_LANGUAGE, 'fr']
export const DEFAULT_NAMESPACE = 'translation'
export const NAMESPACES = [DEFAULT_NAMESPACE]
export const DETECTION_CACHES = ['cookie', 'localStorage']
export const DETECTION_ORDER = [
	'cookie',
	'localStorage',
	'sessionStorage',
	'navigator',
]

export const RESOURCES = {
	en,
	fr,
} as const
